import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../index';
import { QboAccount } from './qbo-account';
import { QboItemIncomeAccount } from './qbo-item-income-account';
import { QboProductIncomeAccount } from './qbo-product-income-account';
import { AdminContextProvider } from '../../context/admin-context';

export function initQboAccount(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('qbo-account');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const props = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <QboAccount {...props} />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}

export function initQboItemIncomeAccount(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('qbo-item-income-account');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const props = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <QboItemIncomeAccount {...props} />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}

export function initQboProductIncomeAccount(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('qbo-product-income-account');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const props = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <QboProductIncomeAccount {...props} />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
